module.exports = __webpack_public_path__ + "img/ic_expertise.0829ff40.svg";